import React from "react";
import { observer } from "mobx-react";
import { store } from "../../store";
import { Alert, AlertCloseButton, AlertDescription, AlertTitle } from "@/components/ui/alert";

export type ErrorsAlertProps = {
    className?: string;
};

export const ErrorsAlert = observer(({ className }: ErrorsAlertProps) => {
    if (!store.serviceErrors.nextError) {
        return <></>;
    }

    const { title, description, id, additionalInformation, html } = store.serviceErrors.nextError;
    return (
        <div className={className}>
            <Alert variant="destructive">
                <AlertTitle>
                    <>{store.i18n.t(title, additionalInformation ?? {})}</>{" "}
                    <>
                        {store.serviceErrors.count > 1 ? (
                            store.i18n.t("component.errorBar.count", {
                                count: store.serviceErrors.count - 1,
                            })
                        ) : (
                            <></>
                        )}
                    </>
                </AlertTitle>
                <AlertDescription>
                    <p>{store.i18n.t(description, additionalInformation)}</p>
                    {html}
                </AlertDescription>
                <AlertCloseButton onClick={() => store.serviceErrors.dismissError(id)} />
            </Alert>
        </div>
    );
});
